<div *ngIf="!buttonFacingRight" (click)="back()"
     class="d-flex w-100 px-3 pointer align-items-center justify-content-start"
>
    <fa-icon [icon]="faIcons.faAngleLeft"></fa-icon>
    <div class="ms-2">{{ text }}</div>
</div>
<div *ngIf="buttonFacingRight" (click)="back()"
     class="d-flex w-100 mx-4 pe-5  my-2 pointer align-items-center justify-content-end"
>
    <div class="mx-2">{{ text }}</div>
    <fa-icon [icon]="faIcons.faAngleLeft"></fa-icon>
</div>
